export const byteArrayToFile = (arr: Uint8Array | number[] | undefined) => {
    if(arr && arr.length > 0){
        let newFile : File = new File([new Uint8Array(arr)], 'tmp.png', { type: 'image/png' });
        return newFile;
    }
    return undefined;
}

export const handleWebsiteLink = (link: string | undefined) => {
    if (!link) {
      return link;
    }
    // Check if the input doesn't start with "http://" or "https://"
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      // Prepend "https://" to the input
      return 'https://' + link;
    }
    return link;
  };